import { Icon } from "@iconify/react";
import { useState } from "react";
import searchFill from "@iconify/icons-eva/search-fill";
// material
import { styled, alpha } from "@mui/material/styles";
import {
  Box,
  Input,
  Slide,
  Button,
  InputAdornment,
  ClickAwayListener,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import { debounceFunc } from "src/utils/helper";

// ----------------------------------------------------------------------

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const SearchbarStyle = styled("div")(({ theme }) => ({
  top: 0,
  left: 0,
  zIndex: 99,
  width: "100%",
  display: "flex",
  position: "absolute",
  alignItems: "center",
  height: APPBAR_MOBILE,
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  padding: theme.spacing(0, 3),
  boxShadow: theme.customShadows.z8,
  backgroundColor: `${alpha(theme.palette.background.default, 0.72)}`,
  [theme.breakpoints.up("md")]: {
    height: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

export default function Searchbar() {
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        {!isOpen && (
          <IconButton onClick={handleOpen}>
            <Icon icon={searchFill} width={20} height={20} />
          </IconButton>
        )}

        <Slide direction="down" in={isOpen} mountOnEnter unmountOnExit>
          <SearchbarStyle>
            <Input
              autoFocus
              fullWidth
              disableUnderline
              placeholder="Search…"
              startAdornment={
                <InputAdornment position="start">
                  <Box
                    component={Icon}
                    icon={searchFill}
                    sx={{ color: "text.disabled", width: 20, height: 20 }}
                  />
                </InputAdornment>
              }
              sx={{ mr: 1, fontWeight: "fontWeightBold" }}
            />
            <Button variant="contained" onClick={handleClose}>
              Search
            </Button>
          </SearchbarStyle>
        </Slide>
      </div>
    </ClickAwayListener>
  );
}

export const CommonSearchbar = ({ placeholder, searchFunc }) => {
  return (
    <Stack
      direction="row"
      // justifyContent="space-between"
      alignItems="center"
      m={2}
      // mr={6}
      spacing={1}
    >
      <TextField
  sx={{
    mx: 1,
    width: {
      xs: "140px", // Extra-small screens (phones)
      sm: "180px", // Small screens
      md: "240px", // Medium screens (tablets)
      lg: "300px", // Large screens (desktops)
    },
    marginLeft: {
      xs: "-10px", // Adjust margin for extra-small screens
      sm: "-12px", // Adjust margin for small screens
      md: "-14px", // Adjust margin for medium screens
      lg: "-16px", // Adjust margin for large screens
    },
  }}
        type="search"
        size="small"
        placeholder={placeholder}
        onChange={(e) => debounceFunc(searchFunc(e))}
      />
      <Button variant="contained"> Search</Button>
    </Stack>
  );
};
